import homeSaga from './resources/Certificate';
import deleteCertificateSaga from './resources/DeleteCertificate';
import licenseSaga from './resources/License';
import passwordSaga from './resources/Password';
import replaceCertificateSaga from './resources/ReplaceCertificate';

const lockerSagas = () => [
  homeSaga(),
  licenseSaga(),
  passwordSaga(),
  deleteCertificateSaga(),
  replaceCertificateSaga()
];

export default lockerSagas;
